import { Button } from 'canoe';
import memoize from 'lodash/memoize';
import React, { useState } from 'react';
import styled from 'styled-components';

const Centered = styled.div`
  text-align: center;
  width: 100%;
  margin: 8px 0;
`;

interface Props<T> {
  /* Amount of items to load each time */
  limit: number;

  /* List of items to iterate through */
  list: T[];

  /* Callback to render components with list items */
  render: (page: T[]) => React.ReactNode;
}

const generateChunks = memoize((array: any, limit: number) => {
  const result = [];
  for (let i = 0, j = array.length; i < j; i += limit) {
    result.push(array.slice(i, i + limit));
  }
  return result;
});

function LoadChunksImpl<T>({ limit, list, render }: Props<T>) {
  const chunks = generateChunks(list, limit);
  const [currentChunk, setCurrentChunk] = useState(0);

  return (
    <>
      {chunks.map((page, index) => {
        if (index > currentChunk) {
          return null;
        }

        if (typeof render !== 'function') {
          return null;
        }

        return render(page);
      })}
      {chunks.length > currentChunk && (
        <Centered>
          <Button onClick={() => setCurrentChunk(currentChunk + 1)}>Load More</Button>
        </Centered>
      )}
    </>
  );
}

export const LoadChunks = React.memo(LoadChunksImpl) as typeof LoadChunksImpl;
